const team = [
  {
    id: 1,
    name: 'Alexandra Morgan',
    role: 'Chief Executive Officer',
    bio: 'Former Goldman Sachs VP with 15+ years in algorithmic trading and fintech innovation.',
    image: '👩',
  },
  {
    id: 2,
    name: 'David Chen',
    role: 'Chief Technology Officer',
    bio: 'Ex-Google engineer specializing in distributed systems and low-latency trading infrastructure.',
    image: '👨',
  },
  {
    id: 3,
    name: 'Sarah Williams',
    role: 'Head of Compliance',
    bio: 'Former SEC regulatory specialist ensuring OrbixGloble meets global financial standards.',
    image: '👩',
  },
]

export default function About() {
  return (
    <main className="min-h-screen">
      {/* Page Header */}
      <section className="gradient-bg text-white py-16">
        <div className="section-container">
          <h1 className="text-4xl md:text-5xl font-display font-bold mb-4">About OrbixGloble</h1>
          <p className="text-lg md:text-xl text-neutral-100 max-w-3xl">
            Building the future of global financial markets through innovation and technology
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="py-16 bg-white">
        <div className="section-container">
          <div className="max-w-4xl mx-auto">
            <h2 className="section-title text-center mb-8">Our Mission</h2>
            <div className="card">
              <p className="text-lg text-neutral-700 leading-relaxed mb-4">
                At OrbixGloble, we believe that sophisticated trading technology should be accessible
                to everyone—from individual retail traders to the largest institutional investors.
                Our mission is to democratize access to global markets while maintaining the highest
                standards of security, reliability, and performance.
              </p>
              <p className="text-lg text-neutral-700 leading-relaxed">
                Founded in 2020, we've grown to serve over 150,000 active traders across 50
                countries, processing billions in daily trading volume. Our platform combines
                institutional-grade infrastructure with intuitive user experiences, powered by
                cutting-edge AI and machine learning technologies.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 bg-neutral">
        <div className="section-container">
          <h2 className="section-title text-center mb-12">Our Core Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="card text-center">
              <div className="text-5xl mb-4">🔒</div>
              <h3 className="font-display font-bold text-xl text-primary mb-3">
                Security First
              </h3>
              <p className="text-neutral-600">
                Bank-grade encryption, multi-factor authentication, and compliance with global
                regulations protect your assets and data.
              </p>
            </div>
            <div className="card text-center">
              <div className="text-5xl mb-4">⚡</div>
              <h3 className="font-display font-bold text-xl text-primary mb-3">
                Innovation
              </h3>
              <p className="text-neutral-600">
                Continuously pushing the boundaries of trading technology with AI-powered insights
                and ultra-low latency execution.
              </p>
            </div>
            <div className="card text-center">
              <div className="text-5xl mb-4">🤝</div>
              <h3 className="font-display font-bold text-xl text-primary mb-3">
                Transparency
              </h3>
              <p className="text-neutral-600">
                Clear pricing, honest communication, and no hidden fees. We believe trust is earned
                through transparency.
              </p>
            </div>
          </div>
        </div>
      </section>


    </main>
  )
}

